/**
 * Constantes du site partagées entre l'application React et `scripts/seo-build.mjs`.
 *
 * Les modules de `src/seo/` et `src/data/` sont chargés tels quels par Node au moment du build
 * (voir `scripts/lib/load-modules.mjs`) : pas d'alias `@/`, pas de JSX, des imports relatifs avec
 * extension `.js`.
 */

export const SITE_URL = "https://flowgantt.eu";
export const SITE_NAME = "FlowGantt";
export const SITE_LANG = "fr-FR";
export const OG_IMAGE_URL = `${SITE_URL}/og-image.png`;
export const LOGO_URL = `${SITE_URL}/logo-512.png`;
export const BLOG_NAME = "Blog FlowGantt";

/**
 * Identifiants des balises JSON-LD. Le pré-rendu et les pages React posent les mêmes ids : quand React démarre,
 * il remplace le bloc statique au lieu de l'ajouter en double.
 */
export const JSONLD_IDS = {
  post: "flowgantt-post-jsonld",
  faq: "flowgantt-faq-jsonld",
  breadcrumb: "flowgantt-breadcrumb-jsonld",
  blog: "flowgantt-blog-jsonld",
  useCase: "flowgantt-usecase-jsonld",
};

/** URL absolue d'un chemin du site ("/blog" → "https://flowgantt.eu/blog"). */
export function absoluteUrl(path = "/") {
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export const postPath = (slug) => `/blog/${slug}`;
export const postUrl = (slug) => absoluteUrl(postPath(slug));

/** Pages marketing connues : cibles valides pour un lien interne écrit dans un article. */
export const STATIC_ROUTES = [
  "/",
  "/pricing",
  "/register",
  "/login",
  "/blog",
  "/legal/mentions",
  "/legal/cgv",
  "/legal/confidentialite",
];
